// extracted by mini-css-extract-plugin
export default {"login-container":"style_login-container__x9ZN0","login-form":"style_login-form__3X0zR"};